import axios from "axios";
import idAuthHeader from "./id-header";

const API_URL = process.env.REACT_APP_API_URL + "api/textcontrol/";

class TextcontrolService {
  async getAuthHeader() {
    return axios.get(API_URL + "auth", {
      headers: await idAuthHeader(),
    });
  }
  async getAccessToken() {
    return axios.get(API_URL + "access", {
      headers: await idAuthHeader(),
    });
  }
}

const textcontrolService = new TextcontrolService();
export default textcontrolService;
